import { Region } from '@lemon8/web-app-shared/i18n';
import { atom } from 'jotai';

export type PageType = 'unsubscribe' | 'unsubscribe-success' | 'subscribe-success';

export interface EmailDataType {
  ticket: string;
  msgId: string;
  timestamp: number;
  from: string;
  to: string;
  sceneId: string;
  tid: number;
  region: Region | '';
  uid?: string;
  aid: string;
  /** 根据参数判断是否可以发起请求 */
  canRequest: boolean;
}

export const EmailRequiredArr: Array<string> = [
  'ticket',
  'msg_id',
  'timestamp',
  'aid',
  'from',
  'to',
  'tid',
  'scene_id',
  'region',
];

export const $EmailData = atom<EmailDataType>({
  ticket: '',
  msgId: '',
  timestamp: 0,
  from: '',
  to: '',
  sceneId: '',
  tid: 0,
  region: '',
  uid: '',
  canRequest: false,
  aid: '',
});

$EmailData.debugLabel = '$EmailData';
